import { useEffect, useState } from 'react'

import { Logo } from 'src/icons'

interface AuthLogoProps {
  src?: string
  /** Company name — used as the img alt/title when the company logo is shown. */
  name?: string
  /** Company branding still resolving — hold the slot empty to avoid flashing
   *  the default mark before the company logo arrives. */
  loading?: boolean
  className?: string
}

const AuthLogo = ({
  src,
  name,
  loading = false,
  className = '',
}: AuthLogoProps) => {
  // A company logo URL is convention-based and may 404 (no upload). On error,
  // fall back to the default mark; reset when src changes.
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [src])

  const showDefault = !src || failed
  const resolvedSrc = showDefault ? Logo : src
  const label = showDefault ? 'Double Nickel' : name || 'Double Nickel'

  return (
    <div className={`flex h-16 items-center justify-center ${className}`}>
      {!loading && (
        <img
          src={resolvedSrc}
          alt={label}
          title={label}
          onError={() => setFailed(true)}
          className="h-14 max-h-full w-auto max-w-[220px] object-contain"
        />
      )}
    </div>
  )
}

export default AuthLogo
